export default function ($translate) {
    return {
        KEYS: {
            ACTIVE: 'ACTIVE',
            INACTIVE: 'INACTIVE'
        },
        LABELS: {
            ACTIVE: $translate.instant('questionCategory.Active'),
            INACTIVE: $translate.instant('questionCategory.Inactive')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/forms/category/question/index.js